import { FC } from 'react';
import { QcsAutocomplete } from './QcsAutocomplete';
import { getFirstLastNameObj } from '../../../utils/format';
import { SUPPLIER_VISIT_FAKE_ID } from '../../../utils/constants';
import { UserState } from '@api/models/enums/UserState';
import { UserRole } from '@api/models/enums/UserRole';
import {
  SupplierEmployeeOptionDto,
  useSupplierEmployeeOrVisitOptions,
} from '../../../hooks/useSupplierEmployeeOrVisitOptions';

interface Props {
  multiple?: boolean;
  name: string;
  label?: React.ReactNode;
  disabled?: boolean;
  required?: boolean;
  supplierId?: string;
  role?: UserRole;
  state?: UserState[];
  excludeIds?: string[];
  style?: React.CSSProperties;
}

export const SupplierEmployeeAutocomplete: FC<Props> = ({
  multiple,
  name,
  label,
  disabled,
  required,
  supplierId,
  role,
  state,
  excludeIds: filterIds,
  style,
}) => {
  const isVisit = supplierId === SUPPLIER_VISIT_FAKE_ID;

  const { options, loading, loadingError, loadOptions, handleGetValueIfNotFound } =
    useSupplierEmployeeOrVisitOptions({
      isVisit,
      supplierId,
      role,
      state,
    });

  const filteredOptions = filterIds ? options.filter((x) => !filterIds.includes(x.id!)) : options;

  return (
    <QcsAutocomplete<SupplierEmployeeOptionDto>
      style={style}
      multiple={multiple}
      name={name}
      label={label}
      required={required}
      disabled={disabled}
      options={filteredOptions}
      loading={loading}
      loadingError={loadingError}
      loadOptions={loadOptions}
      getOptionId={(option) => option.id!}
      getOptionName={getFirstLastNameObj}
      getValueIfNotFound={handleGetValueIfNotFound}
    />
  );
};
